
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Sidebar from './Sidebar';
import { Session } from "./utils/session";
import { API_BASE_URL } from '../config';

export default function TeamsTab() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  /* ================= AUTH HEADER ================= */
const authHeaders = () => {
  const token = Session.getToken();

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
};

  const workspaceFromState = location.state && location.state.workspace ? location.state.workspace : null;

  const [activeTab, setActiveTab] = useState('general');
  const [formData, setFormData] = useState({
  WorkspaceID: '',
  WorkspaceName: '',
  Description: '',
  IsActive: false,
  CreatedAt: '',
  OwnerUserID: Session.getUserId() // ✅ FIX
});
  const [members, setMembers] = useState([]);
  const [membersLoading, setMembersLoading] = useState(false);
  const [membersError, setMembersError] = useState(null);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedMemberUserIds, setSelectedMemberUserIds] = useState([]);
  const selectedMemberList = useMemo(() => members.filter((m) => selectedMembers.includes(m._id)), [members, selectedMembers]);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [nameError, setNameError] = useState('');
  const [checkingName, setCheckingName] = useState(false);
  const workingMembers = members.filter((m) => {
    const s = (m.Status || '').toString().toLowerCase();
    if (s.includes('removed')) return false;
    if (s.includes('invited')) return false;
    return s.includes('active') || s.includes('member') || s === '' || s === 'active';
  });

  const formatDate = useCallback((raw) => {
    if (!raw) return '';
    let date = new Date(raw);
    if (isNaN(date.getTime())) {
      const msMatch = String(raw).match(/\/(?:Date)?\((\d+)\)\//i) || String(raw).match(/^\d{10,}$/);
      if (msMatch) {
        const ts = Number(msMatch[1]);
        date = new Date(ts < 1e12 ? ts * 1000 : ts);
      }
    }
    if (isNaN(date.getTime())) return String(raw);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  }, []);

  useEffect(() => {
  if (workspaceFromState) {
    setFormData((prev) => ({
 ...prev,
      WorkspaceID:
        workspaceFromState.WorkspaceID ??
        workspaceFromState.workspaceID ??
        workspaceFromState.id ??
        '',

      WorkspaceName:
        workspaceFromState.WorkspaceName ??
        workspaceFromState.workspaceName ??
        workspaceFromState.name ??
        '',

      Description:
        workspaceFromState.Description ??
        workspaceFromState.description ??
        '',

      IsActive:
        workspaceFromState.IsActive ??
        workspaceFromState.isActive ??
        false,

      CreatedAt:
        workspaceFromState.CreatedAt ??
        workspaceFromState.createdAt ??
        workspaceFromState.created_at ??
        '',

      // ✅ THIS IS THE FIX
      OwnerUserID:
        workspaceFromState.OwnerUserID ??
        workspaceFromState.ownerUserId ??
        workspaceFromState.owner_user_id ??
        null
    }));
  } else if (params.id) {
    setFormData((prev) => ({
      ...prev,
      WorkspaceID: params.id
    }));
  }
}, [workspaceFromState, params.id]);

  useEffect(() => {
    if (activeTab !== 'members') return;

    const loadMembers = async () => {
      try {
        setMembersLoading(true);
        setMembersError(null);

        const response = await fetch(`${API_BASE_URL}/api/Members/Users_List`, {
      headers: authHeaders()  // ✅ uses your helper?workspaceName=IME
    });

        if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

        const data = await response.json();

        let data1 = null;

      try {
  const response1 = await fetch(
    `${API_BASE_URL}/api/Workspace/Members_By_WorkspaceID?workspaceId=${formData.WorkspaceID}`,
    {
      headers: authHeaders()  // ✅ include your auth token here
    }
  );

  if (response1.ok) {
    data1 = await response1.json();
    console.log("Workspace members:", data1);
  } else {
    console.warn("API returned non-OK status:", response1.status, response1.statusText);
  }
} catch (err) {
  console.warn("Failed to fetch workspace members:", err.message);
}


        const normalized = Array.isArray(data)
          ? data.map((u) => ({
            Name:
              u.Name ?? u.name ?? u.fullName ?? `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim() ?? '',
            CreatedAt: formatDate(u.createdOn ?? u.createdOn ?? u.createdOn ?? u.createdOn ?? ''),
            Email: u.email ?? u.Email ?? '',
            Role: u.role ?? u.Role ?? u.type ?? 'Member',
            Status: (u.IsActive ?? u.isActive ?? u.active ?? (u.status === 'active')) ? 'Active' : (u.status ?? 'Removed'),
            _raw: u
          }))
          : [];

        const workspaceIdSet = new Set();
        const workspaceEmailSet = new Set();
        if (Array.isArray(data1)) {
          data1.forEach((w) => {
            const wid = w.userID ?? w.UserID ?? w.UserId ?? w.id ?? w._id ?? w.userId ?? null;
            if (wid != null) workspaceIdSet.add(String(wid));
            const wem = (w.Email ?? w.email ?? w.EmailAddress ?? w.emailAddress ?? null);
            if (wem) workspaceEmailSet.add(String(wem).toLowerCase());
          });
        }

        const selectedInitial = [];
        const selectedInitialUserIds = [];

        normalized.forEach((m, idx) => {
          if (!m._id) m._id = m.Email || `member-${idx}`;

          const raw = m._raw || {};
          const rawId = raw.userId ?? raw.UserID ?? raw.UserId ?? raw.id ?? raw._id ?? null;
          const rawEmail = (m.Email || raw.email || raw.Email || '').toString().toLowerCase();
          const isInWorkspace = (rawId != null && workspaceIdSet.has(String(rawId))) || (rawEmail && workspaceEmailSet.has(rawEmail));

          if (isInWorkspace) {
            m.Status = 'Active';
            selectedInitial.push(m._id);
            if (rawId != null) selectedInitialUserIds.push(String(rawId));
          }
        });

        setMembers(normalized);
        if (selectedInitial.length > 0) setSelectedMembers((prev) => Array.from(new Set([...prev, ...selectedInitial])));
        if (selectedInitialUserIds.length > 0) setSelectedMemberUserIds((prev) => Array.from(new Set([...prev, ...selectedInitialUserIds])));
      } catch (err) {
        console.error('Error loading members:', err);
        setMembersError(err.message || 'Something went wrong');
      } finally {
        setMembersLoading(false);
      }
    };

    loadMembers();
  }, [activeTab, formData.WorkspaceID]);

  const handleChange = useCallback((e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError(null);
    
    if (!formData.WorkspaceName || !formData.WorkspaceName.toString().trim()) {
      setNameError('Workspace name is required');
      setSubmitError('Workspace name is required');
      return;
    }
    
    if (formData.WorkspaceName) {
      try {
        setCheckingName(true);
        const dup = await checkNameExists(formData.WorkspaceName, formData.WorkspaceID);
        if (dup) {
          setNameError('Name already available');
          setSubmitError('Workspace name already available');
          setCheckingName(false);
          return;
        }
      } finally {
        setCheckingName(false);
      }
    }
    if (!formData.WorkspaceID || Number(formData.WorkspaceID) <= 0) {
      setSubmitError('Invalid WorkspaceID');
      return;
    }
    setSubmitting(true);
    try {
     const payload = {
      WorkspaceID: Number(formData.WorkspaceID),
      WorkspaceName: formData.WorkspaceName,
     Description: formData.Description,
     IsActive: !!formData.IsActive,
     OwnerUserID: Session.getUserId() // ✅ BEST
};


     const resp = await fetch(`${API_BASE_URL}/api/Workspace/Update_Workspace`, {
  method: 'POST', // or PUT if backend supports
  headers: authHeaders(), // includes Content-Type + Authorization
  body: JSON.stringify(payload),
});

      if (!resp.ok) {
        const text = await resp.text().catch(() => null);
        throw new Error(text ? `${resp.status} - ${text}` : `Request failed with status ${resp.status}`);
      }

      if (selectedMemberUserIds && selectedMemberUserIds.length > 0) {
        try {
          const validUserIds = selectedMemberUserIds
            .map((uid) => Number(uid))
            .filter((n) => !isNaN(n) && n > 0);

          if (validUserIds.length > 0) {
            const memberPayload = {
              UserIDs: validUserIds,
              WorkspaceID: Number(formData.WorkspaceID),
              Role: null,
              CreatedAt: new Date().toISOString()
            };  
           const response = await fetch(`${API_BASE_URL}/api/Workspace/Insert_update_WorkspaceMember`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${Session.getToken()}`
  },
  body: JSON.stringify(memberPayload)
});


            if (!response.ok) {
              const errorText = await response.text().catch(() => null);
              throw new Error(errorText || `Request failed with status ${response.status}`);
            }
          }
        } catch (err) {
          console.error('Error upserting workspace members:', err);
          setSubmitError(err.message || 'Failed to upsert workspace members');
          setSubmitting(false);
          return;
        }
      }

      navigate('/teams');
    } catch (err) {
      console.error('Error updating workspace:', err);
      setSubmitError(err.message || 'Failed to update workspace');
    } finally {
      setSubmitting(false);
    }
  };

  const checkNameExists = useCallback(async (name, excludeId) => {
    if (!name) return false;
    try {
      const resp = await fetch(`${API_BASE_URL}/api/Workspace/Workspaces_List`,
      {
        headers: authHeaders() 
      }
    );
      if (!resp.ok) return false;
      const data = await resp.json();
      if (!Array.isArray(data)) return false;
      const lc = name.toString().trim().toLowerCase();
      return data.some((w) => {
        const n = (w.WorkspaceName ?? w.workspaceName ?? w.name ?? '').toString().trim().toLowerCase();
        const id = w.WorkspaceID ?? w.workspaceID ?? w.workspaceId ?? w.id ?? w._id ?? null;
        const idStr = id != null ? String(id) : '';
        const excludeStr = excludeId != null ? String(excludeId) : '';
        return n === lc && idStr !== excludeStr;
      });
    } catch (e) {
      console.warn('Name check failed', e);
      return false;
    }
  }, []);

  const toggleSelectMember = useCallback((id) => {
    setSelectedMembers((prev) => {
      const isSelected = prev.includes(id);
      const next = isSelected ? prev.filter((x) => x !== id) : [...prev, id];
      setMembers((cur) =>
        cur.map((m) => {
          if (m._id === id || m.Email === id) {
            if (isSelected) {
              const newRaw = { ...(m._raw || {}) };
              delete newRaw.invitedAt;
              return { ...m, Status: 'Active', _raw: newRaw };
            }
            return { ...m, Status: 'Invited', _raw: { ...(m._raw || {}), invitedAt: new Date().toISOString() } };
          }
          return m;
        })
      );
      try {
        const m = members.find((mm) => (mm._id === id || mm.Email === id));
        const raw = m?._raw || {};
        const rawId = raw.userId ?? raw.UserID ?? raw.UserId ?? raw.id ?? raw._id ?? null;
        if (rawId != null) {
          setSelectedMemberUserIds((prevIds) => {
            const sid = String(rawId);
            if (isSelected) return prevIds.filter((x) => x !== sid);
            return Array.from(new Set([...prevIds, sid]));
          });
        }
      } catch (e) {
        // ignore
      }
      return next;
    });
  }, [members]);

  const toggleSelectAll = useCallback(() => {
    const ids = workingMembers.map((m, idx) => m._id || m.Email || `member-${idx}`);
    members.forEach((m, idx) => {
      if (!m._id) m._id = m.Email || `member-${idx}`;
    });
    const allSelected = ids.length > 0 && ids.every((id) => selectedMembers.includes(id));
    if (allSelected) {
      setSelectedMembers((prev) => prev.filter((id) => !ids.includes(id)));
      setMembers((cur) => cur.map((m) => (ids.includes(m._id) ? ({ ...m, Status: 'Active', _raw: (() => { const r = { ...(m._raw || {}) }; delete r.invitedAt; return r; })() }) : m)));
      setSelectedMemberUserIds((prevIds) => {
        const idsSet = new Set(ids);
        return prevIds.filter((pid) => {
          const member = members.find((mm) => {
            const raw = mm?._raw || {};
            const rawId = raw.userId ?? raw.UserID ?? raw.UserId ?? raw.id ?? raw._id ?? null;
            return rawId != null && String(rawId) === String(pid) && idsSet.has(mm._id);
          });
          return !member;
        });
      });
    } else {
      setSelectedMembers((prev) => Array.from(new Set([...prev, ...ids])));
      setMembers((cur) => cur.map((m) => (ids.includes(m._id) ? { ...m, Status: 'Invited', _raw: { ...(m._raw || {}), invitedAt: new Date().toISOString() } } : m)));
      setSelectedMemberUserIds((prevIds) => {
        const toAdd = [];
        ids.forEach((id) => {
          const mm = members.find((m) => m._id === id || m.Email === id);
          const raw = mm?._raw || {};
          const rawId = raw.userId ?? raw.UserID ?? raw.UserId ?? raw.id ?? raw._id ?? null;
          if (rawId != null) toAdd.push(String(rawId));
        });
        return Array.from(new Set([...prevIds, ...toAdd]));
      });
    }
  }, [workingMembers, members, selectedMembers]);


  const displayedMembers = useMemo(() => members.filter((m) => {
    const s = (m.Status || '').toString().toLowerCase();
    return !s.includes('removed');
  }), [members]);

  return (
    <div>
      <div id="sidebar-overlay" />
      <Sidebar />
      <div id="content">
        <div className="product-page-wrapper">
          <div className="product-page container-fluid">
            <style>{`
            .product-page-wrapper {
              background-color: #f8f9fa;
              padding: 30px 0;
            }
            .main-card {
              margin: 0 auto;
              box-shadow: 0 4px 12px rgba(0,0,0,0.08);
              border: none;
            }
            .btn-primary { background: #0084fe; border-color: #0084fe; color: #fff; }
            .btn-primary:hover, .btn-primary:focus { background: #13846f; border-color: #13846f; color: #fff; }
            .btn-outline-secondary { background: transparent; border: 1px solid #ced4da; color: #495057; }
            .btn-outline-secondary:hover { background: rgba(23,165,137,0.06); }

            .member-section {
              margin-bottom: 40px;
              border: 1px solid #eee;
              padding: 16px;
              border-radius: 8px;
              background: #fff;
              box-shadow: 0 1px 3px rgba(0,0,0,0.03);
            }
            .section-header { margin-bottom: 12px; }

            .badge-warning { background: #ffeeba; color: #856404; font-size: 14px; padding: 6px 12px; border-radius: 12px; }
            .badge-secondary { background: #e2e3e5; color: #41464b; font-size: 14px; padding: 6px 12px; border-radius: 12px; }
            .badge-success { background: #d4edda; color: #094073ff; font-size: 14px; padding: 6px 12px; border-radius: 12px; }

            .member-table { width: 100%; border-collapse: collapse; }
            .member-table thead th { color: #6c757d; font-size: 13px; text-transform: uppercase; padding: 10px; border-bottom: 2px solid #f1f1f1; }
            .member-table td { padding: 12px 10px; vertical-align: middle; border-bottom: 1px solid #f6f6f6; }
            .member-table tr.removed-row { opacity: 0.6; }

            .nav-tabs {
              border-bottom: 1px solid #dee2e6;
            }
            .nav-tabs .nav-link {
              border: none;
              border-bottom: 3px solid transparent;
              color: #6c757d;
              font-weight: 500;
            }
            .nav-tabs .nav-link.active {
              border-bottom-color: #0084fe;
              color: #0084fe;
              background-color: transparent;
            }

            .form-check-input:checked{
             background-color: #0084fe;
             border-color: #0084fe;
             }

            input[type="checkbox"] { width: 18px; height: 18px; cursor: pointer; accent-color: #0084fe; }
            .member-table td input[type="checkbox"] { display: inline-block; margin: 0; }

            @media (max-width: 768px) {
              .member-table thead th, .member-table td { font-size: 13px; }
            }
          `}</style>

            <form onSubmit={handleSubmit} noValidate className='main-card'>
              <div className="panel panel-default">
                <div className="panel-body p-0">
                  <div className="mb-0 p-4">
                    <h4 className="mb-3">Team</h4>
                    <ul className="nav nav-tabs">
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === 'general' ? 'active' : ''}`}
                          onClick={() => setActiveTab('general')}
                          type="button"
                        >
                          General
                        </button>
                      </li>
                      <li className="nav-item">
                        <button
                          className={`nav-link ${activeTab === 'members' ? 'active' : ''}`}
                          onClick={() => setActiveTab('members')}
                          type="button"
                        >
                          Members
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div className="tab-content px-4 pt-2">
                    {activeTab === 'general' && (
                      <div className="tab-pane fade show active">
                        <div className="row">
                          <div className="form-group col-md-6 mb-3">
                            <label>Name</label>
                            <input
                              type="text"
                              name="WorkspaceName"
                              className="form-control"
                              value={formData.WorkspaceName}
                              onChange={(e) => {
                                if (nameError) setNameError('');
                                handleChange(e);
                              }}
                              onBlur={async (e) => {
                                const val = e.target.value && e.target.value.toString().trim();
                                if (!val) {
                                  setNameError('');
                                  return;
                                }
                                setNameError('');
                                try {
                                  setCheckingName(true);
                                  const exists = await checkNameExists(val, formData.WorkspaceID);
                                  if (exists) setNameError('Name already available');
                                } finally {
                                  setCheckingName(false);
                                }
                              }}
                            />
                            {nameError && <small className="text-danger d-block mt-1">{nameError}</small>}
                          </div>

                          <div className="form-group col-12  mb-3">
                            <label>Description</label>
                            <textarea name="Description" className="form-control" value={formData.Description} onChange={handleChange} />
                          </div>

                          <div className="form-group col-md-6 d-flex align-items-center">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                name="IsActive"
                                checked={formData.IsActive}
                                onChange={handleChange}
                                className="form-check-input"
                                id="IsActive"
                              />
                              <label htmlFor="IsActive" style={{ marginLeft: '8px' }}>
                                Is Active
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {activeTab === 'members' && (
                      <div className="tab-pane fade show active">
                        <div className="member-section">
                          <span className="badge"
                            style={{
                              marginTop: "2px",
                              marginLeft: "10px",
                              marginBottom: "10px",
                              fontSize: 16,
                              color: "black",
                              fontWeight: "bold",
                            }}
                          >
                            Invited
                          </span>
                          <table className="table member-table">
                            <thead>
                              <tr>
                                <th style={{ width: 48, textAlign: 'center' }}>
                                  <input
                                    type="checkbox"
                                    aria-label="Select all members"
                                    checked={displayedMembers.length > 0 && displayedMembers.every((m) => selectedMembers.includes(m._id))}
                                    onChange={toggleSelectAll}
                                  />
                                </th>
                                <th>Name</th>
                                <th>Invited At</th>
                                <th>Email</th>
                                <th>Type</th>
                                <th>Invitation</th>
                              </tr>
                            </thead>
                            <tbody>
                              {membersLoading && (
                                <tr>
                                  <td colSpan={6} className="text-center text-muted py-3">Loading members...</td>
                                </tr>
                              )}

                              {membersError && (
                                <tr>
                                  <td colSpan={6} className="text-center text-danger py-3">Error: {membersError}</td>
                                </tr>
                              )}

                              {!membersLoading && !membersError && displayedMembers.length === 0 && (
                                <tr>
                                  <td colSpan={6} className="text-center text-muted py-3">No members found.</td>
                                </tr>
                              )}

                              {!membersLoading && !membersError && displayedMembers.map((m, idx) => {
                                const id = m._id || m.Email || `member-${idx}`;
                                if (!m._id) m._id = id;
                                return (
                                  <tr key={id} className={m.Status && m.Status.toLowerCase().includes('removed') ? 'removed-row' : ''}>
                                    <td style={{ width: 48, textAlign: 'center' }}>
                                      <input
                                        type="checkbox"
                                        value={id}
                                        checked={selectedMembers.includes(id)}
                                        onChange={() => toggleSelectMember(id)}
                                      />
                                    </td>
                                    <td>{m.Name}</td>
                                    <td>{m.CreatedAt}</td>
                                    <td>{m.Email}</td>
                                    <td>{m.Role}</td>
                                    <td className={m.Status && m.Status.toLowerCase().includes('removed') ? 'text-danger' : ''}>{m.Status} </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-12 mt-3 d-flex px-4" style={{ gap: 8 }}>
                    <button type="submit" className="btn btn-primary" disabled={submitting || checkingName || !!nameError || !formData.WorkspaceName}>
                      {submitting ? 'Saving...' : checkingName ? 'Checking...' : 'Save'}
                    </button>
                    <button type="button" className="btn btn-outline-secondary" onClick={() => navigate('/teams')}>Cancel</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
